import React from 'react';
import { TpPromptTaskContext, TpTaskFormData, TpTaskFormElemDef, TpTaskFormParsedElemData } from './interfaces';
import { ElemValueWrapper } from '../helpers/ElemValueWrapper';

function setInitialData(elemDef: any, ctx: TpPromptTaskContext, formData: TpTaskFormData) {
  formData.elemValues[elemDef.id] = elemDef.defaultValue;
}

function generate(
  elemDef: any,
  ctx: TpPromptTaskContext,
  formData: TpTaskFormData,
  updateElemValue: (elemId: string, newValue: any) => void,
) {
  return (
    <ElemValueWrapper elemName={elemDef.displayName}>
      <input
        id={elemDef.id}
        value={formData.elemValues[elemDef.id] || ''}
        onChange={(ev) => {
          updateElemValue(elemDef.id, ev.target.value);
        }}
      />
    </ElemValueWrapper>
  );
}

function parseElemValue(ctx: TpPromptTaskContext, elemDef: any, input: any): TpTaskFormParsedElemData {
  if (elemDef.required && (input === null || input === undefined || input === '')) {
    return { value: null, errorString: 'Missing required field' };
  }
  return {
    value: input,
    errorString: null,
  };
}

const taskFormElemStringDef: TpTaskFormElemDef = {
  type: 'string',
  name: 'String',
  description: 'Prompts the user for a text string',
  hasData: true,
  setInitialData,
  generate,
  parseElemValue,
};

export default taskFormElemStringDef;
